var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-container"},[_c('div',{staticClass:"error-box"},[_c('h3',{staticClass:"error-title"},[_vm._v("카카오 로그인에 실패했습니다.")]),_c('p',{staticClass:"error-message"},[_vm._v(_vm._s(_vm.errorMessage))]),_c('button',{staticClass:"main-button",on:{"click":_vm.goToMain}},[_vm._v("확인")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }